/*
 * Builds an "on this page" list for Shopify's policy pages.
 *
 * Shopify renders policy bodies from rich text and gives the headings no ids,
 * so there is nothing to link to until we add them. This script only ever adds
 * markup — it never hides or moves anything the reader can already see, so if
 * it throws, the policy is still a complete, readable document.
 */
(function () {
  'use strict';

  var mount = document.querySelector('[data-policy-toc]');
  var body = document.querySelector('.shopify-policy__body');
  if (!mount || !body) return;

  var headings = body.querySelectorAll('h2');
  if (headings.length < 3) return; // not enough structure to be worth a list

  function slugify(text, index) {
    var base = text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60);
    return base ? base : 'section-' + index;
  }

  var used = Object.create(null);
  var items = [];

  Array.prototype.forEach.call(headings, function (heading, index) {
    var label = (heading.textContent || '').trim();
    if (!label) return;

    if (!heading.id) {
      var slug = slugify(label, index);
      if (used[slug]) {
        used[slug] += 1;
        slug = slug + '-' + used[slug];
      } else {
        used[slug] = 1;
      }
      heading.id = slug;
    }
    heading.style.scrollMarginTop = 'var(--chittera-policy-scroll-offset, 6rem)';
    items.push({ id: heading.id, label: label, el: heading });
  });

  if (items.length < 3) return;

  var title = document.createElement('p');
  title.className = 'chittera-policy__navtitle';
  title.textContent = 'On this page';

  var nav = document.createElement('nav');
  nav.setAttribute('aria-label', 'On this page');

  var list = document.createElement('ul');
  var links = {};

  items.forEach(function (item) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + item.id;
    a.textContent = item.label;
    links[item.id] = a;
    li.appendChild(a);
    list.appendChild(li);
  });

  nav.appendChild(title);
  nav.appendChild(list);
  mount.appendChild(nav);

  if (!('IntersectionObserver' in window)) return;

  var active = null;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var next = links[entry.target.id];
        if (!next || next === active) return;
        if (active) active.removeAttribute('aria-current');
        next.setAttribute('aria-current', 'true');
        active = next;
      });
    },
    { rootMargin: '-10% 0px -70% 0px' }
  );

  items.forEach(function (item) {
    observer.observe(item.el);
  });
})();
